/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coinvestments_Dataroom_Unsavedchanges3Inputs */

const en_coinvestments_dataroom_unsavedchanges3 = /** @type {(inputs: Coinvestments_Dataroom_Unsavedchanges3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} unsaved changes`)
};

/**
* | output |
* | --- |
* | "{count} unsaved changes" |
*
* @param {Coinvestments_Dataroom_Unsavedchanges3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_unsavedchanges3 = /** @type {((inputs: Coinvestments_Dataroom_Unsavedchanges3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Unsavedchanges3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_unsavedchanges3(inputs)
});
export { coinvestments_dataroom_unsavedchanges3 as "coInvestments_dataRoom_unsavedChanges" }